import { render, staticRenderFns } from "./KiddiesAccount.vue?vue&type=template&id=36401b5f&scoped=true"
import script from "./KiddiesAccount.vue?vue&type=script&lang=js"
export * from "./KiddiesAccount.vue?vue&type=script&lang=js"
import style0 from "./KiddiesAccount.vue?vue&type=style&index=0&id=36401b5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36401b5f",
  null
  
)

export default component.exports